export const API_ERRORS = {
  ALIAS: {
    ALIAS_ERROR: 'form_alias_error',
    ALIAS_IN_USE: 'form_alias_in_use'
  },
  ACCOUNT: {
    TERMS_OF_USE_VIOLATION_ERROR: 'terms_of_use_violation_error'
  },
  ENTRY: {
    CREATE_ERROR: 'entry_create_error',
    EMAIL_ERROR: 'entry_email_error',
    DELETE_ERROR: 'entry_delete_error',
    UPDATE_ERROR: 'entry_update_error',
  },
  ENTRIES: {
    FETCH_ERROR: 'entries_fetch_error',
  },
  FORM: {
    AUTHENTICATION_ERROR: 'not_authenticated',
    AUTHORIZATION_ERROR: 'not_authorized',
    CREATE_ERROR: 'form_create_error',
    FETCH_ERROR: 'form_fetch_error',
    NOT_FOUND_ERROR: 'form_not_found_error',
    PUBLISH_ERROR: 'form_publish_error',
    SAVE_CONFLICT: 'form_save_conflict',
    SAVE_ERROR: 'form_save_error'
  },
  FILE: {
    FETCH_ERROR: 'file_fetch_error',
    UPLOAD_ERROR: 'file_upload_error',
  },
  RESPONDENT: {
    AUTHENTICATION_ERROR: 'public_form_submit_authentication_error',
    FETCH_ERROR: 'public_form_fetch_error',
    FORM_CLOSED: 'form_is_closed_error',
    NOT_FOUND: 'form_does_not_exist',
    SUBMIT_ERROR: 'public_form_submit_error',
  }
}

export const INTERNAL_ERROR = '0000'
export const INVALID_TYPE = '0001'
export const OUT_OF_RANGE = '0002'
export const NOT_UNIQUE = '0004'
export const INVALID_FORMAT = '0006'
export const FILE_TOO_LARGE = '0007'
export const INVALID_FILE_TYPE = '0009'
export const FORM_UPLOAD_LIMIT_EXCEEDED = '0010'
export const VALUE_IS_REQUIRED = '0013'
export const LIMIT_EXCEEDED = '0014'
export const DUPLICATES_NOT_ALLOWED = '0015'
export const OUT_OF_LIST = '0016'
export const PATH_NOT_FOUND = '0017'
export const INVALID_PATTERN = '0018'
export const OBJECT_NOT_FOUND = '0019'
export const REFERENCE_NOT_FOUND = '0020'
export const ACCOUNT_LOCKED = '0021'
export const INVALID_CREDENTIALS = '0022'
export const EMAIL_ALREADY_VERIFIED = '0023'
export const INVALID_BODY = '0024'
export const PASSWORDS_DO_NOT_MATCH = '0025'
export const PASSWORD_USED_BEFORE = '0026'
export const INVALID_TOKEN = '0027'
export const FORBIDDEN_PERMISSION = '0028'
export const UNAUTHORIZED_REQUEST = '0029'
export const SERVICE_NOT_AVAILABLE = '0030'
export const EXPORT_STATE_CONFLICT = '0031'
export const INVALID_CONDITION = '0032'
export const ETAG_NOT_MATCHED = '0033'
export const NOT_UNIQUE_FORM_ALIAS = '0034'
export const FORM_IS_CLOSED = '0035'
export const FORBIDDEN_ACCOUNT = '0036'
export const INVALID_VALUE = '0037'
export const TERMS_OF_USE_VIOLATION_ERROR = '0039'

export const DEFAULT_ERROR = INTERNAL_ERROR

export const RESPONDENT_ERROR_MAP = {
  [DEFAULT_ERROR]: API_ERRORS.RESPONDENT.FETCH_ERROR,
  [FORM_IS_CLOSED]: API_ERRORS.RESPONDENT.FORM_CLOSED,
  [OBJECT_NOT_FOUND]: API_ERRORS.RESPONDENT.NOT_FOUND,
  [REFERENCE_NOT_FOUND]: API_ERRORS.RESPONDENT.NOT_FOUND,
}

export const RESPONDENT_SUBMISSION_ERROR_MAP = {
  [DEFAULT_ERROR]: API_ERRORS.RESPONDENT.SUBMIT_ERROR,
  [INVALID_VALUE]: API_ERRORS.RESPONDENT.AUTHENTICATION_ERROR,
  [TERMS_OF_USE_VIOLATION_ERROR]: API_ERRORS.ACCOUNT.TERMS_OF_USE_VIOLATION_ERROR
}

export const EMBED_ERRORS = [ API_ERRORS.FORM.AUTHENTICATION_ERROR, API_ERRORS.FORM.SAVE_CONFLICT ]
